module.exports = __webpack_public_path__ + "media/components/src/assets/images/coupon/coupon_1-02a93962f14912b6aa568b4518eaaff2.jpg";